// DO NOT CHANGE -- THIS FILE IS GENERATED

const theme = {
  primary: '#00A19c',
  secondary: '#3587A4',
  third: '#4B1D3F',
};

export default theme;
